import { render, staticRenderFns } from "./FourOhFour.vue?vue&type=template&id=ff7aa01e&scoped=true&"
import script from "./FourOhFour.vue?vue&type=script&lang=js&"
export * from "./FourOhFour.vue?vue&type=script&lang=js&"
import style0 from "./FourOhFour.vue?vue&type=style&index=0&id=ff7aa01e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7aa01e",
  null
  
)

export default component.exports